// Brillenhaus – "Passt zu": findet zur Modellnummer (z. B. UN818) die passende Fassung bzw. die passenden Clips.
const esc = (value) => String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

function modelKey(title) {
  const isAmount = (t) => /^\d+([.,]\d+)?(ml|l|er|stk|stück|g|mm|%)$/i.test(t);
  const tokens = title.split(/\s+/).map((t) => t.replace(/[(),]/g, ''));
  const coded = tokens.find((t) => /\d/.test(t) && !isAmount(t) && t.replace(/\D/g, '').length >= 3 && t.length >= 4);
  if (!coded) return '';
  const parts = coded.split('-');
  return parts.length > 1 && parts.slice(0, -1).join('-').length >= 3 ? parts.slice(0, -1).join('-') : coded;
}

const isClip = (t) => /clip/i.test(t) && !/brille/i.test(t);
const isClipFrame = (t) => /brille mit clip/i.test(t);

const money = (cents, format) => {
  const [int, dec] = (Number(cents) / 100).toFixed(2).split('.');
  return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`);
};

async function init(root) {
  if (root.dataset.bhReady) return;
  root.dataset.bhReady = 'true';
  const { title, handle, vendor, mode, money: format, hClip, hFrame } = root.dataset;
  const key = modelKey(title);
  if (!key) return;
  let products = [];
  try {
    const url = `/search/suggest.json?q=${encodeURIComponent(key)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide`;
    products = (await fetch(url).then((r) => r.json()))?.resources?.results?.products || [];
  } catch {
    return;
  }
  const matches = products.filter(
    (p) => p.handle !== handle && p.title.includes(key) && (!vendor || p.vendor === vendor) && (mode === 'clip' ? isClipFrame(p.title) : isClip(p.title))
  );
  if (!matches.length) return;
  const priceOf = (p) => {
    const raw = p.price ?? p.price_min;
    const cents = String(raw).includes('.') ? Math.round(parseFloat(raw) * 100) : Number(raw);
    return money(cents, format);
  };
  const list = root.querySelector('[data-bh-match-list]');
  list.innerHTML = `
    <p class="bh-fit-match__heading">${esc(mode === 'clip' ? hClip : hFrame)}</p>
    <div class="bh-fit-match__cards">
      ${matches
        .slice(0, 3)
        .map(
          (p) => `<a class="bh-fit-match__card" href="/products/${encodeURIComponent(p.handle)}">
            ${p.featured_image?.url ? `<img src="${esc(p.featured_image.url)}${p.featured_image.url.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy">` : '<span></span>'}
            <span class="bh-fit-match__name">${esc(p.title)}</span>
            <span class="bh-fit-match__price">${esc(priceOf(p))}</span>
          </a>`
        )
        .join('')}
    </div>`;
  list.hidden = false;
}

document.querySelectorAll('[data-bh-match]').forEach(init);
